<template>
  <div>
    <!-- {{product}} -->
    <p class="select-size" :class="isMoveToCartPopup ? 'mt-0 mb-3' : ''"  v-if="isOptions === true"><span style="font-weight: bold"> {{ platform === 'KIDS' ? 'Age' : 'Size'}} not available? &nbsp;</span>
      <span 
        @click="showPopover" 
        class="selectcolor pointer">Notify Me
      </span> <br>
    </p>
    <div class="inlineblock" v-if="isOptions === true">
      <div class="mobileOverlayLayer" v-if="showPopup">
      <!-- <a href="javascript:void(0)" class="disableclick"></a> -->
        <div class="user-popover" v-if="showPopup" transition="fade" :style="'left:-' + (position * 40 + 12) + 'px'">
          <button class="closebx close" type='button' aria-label="Close" @click="hoverOutInfo">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="productSize">
            <p><b>Please select {{ platform === 'KIDS' ? 'an age' : 'your size'}} </b></p>
            <ul class="sizelist">
              <li v-for="(val, key, index) in getFilteredSize" :key="index">
                <div v-if="(val.stock === 0 || isSouledOut)" :class="(val.id === selectedSize) ? 'selectedSize' : 'unselectedSize'" class="oval">
                  <input type="radio" name="sub_prod" :id="key" :value="val.id" v-model="selectedSize"
                  @change="changeSize(selectedSize)">
                  <label  style="border-radius:50%" :for="key">
                    <span class="" v-if="val.stock <= 0">{{val.attributes[0].value}}</span>
                    <span class="sizetext" v-else>{{val.attributes[0].value}}</span>
                  </label>
                </div>
              </li> 
            </ul>
          </div>
          <div class="bottomSection">
            <h3>Get notified once the product is back in stock.</h3>
            <form method="POST" v-on:submit.prevent="notifyproduct">
              <div class="row" v-if="proType===3 || proType===6">
                <input type="hidden" v-model="notify.prod_id" :value="parentid">
                <input type="hidden" v-model="notify.sub_prod_id" :value="szid">
                <input type="hidden" v-model="notify.prod_type" :value="proType">
                <div class="col-8 pro">
                  <input type="text" name="notify.email" v-model="email" class="form-control" placeholder="Enter your email ID">
                  <div class="message" v-if="nullError">{{ nullError }}</div>
                </div>
                <div class="col-4">
                  <button :disabled="notifyBtnDisabled" class="btn btn-primary btn-block">Submit</button>
                </div>
              </div>
              <div class="row" v-if="proType===2">
                <input type="hidden" v-model="notify.prod_id" :value="parentid">
                <input type="hidden" v-model="notify.sub_prod_id" :value="szid">
                <input type="hidden" v-model="notify.prod_type" :value="proType">
                <div class="col-8 pro">
                  <input type="text" name="email" v-model="email" class="form-control" placeholder="Enter your email ID">
                  <div class="message" v-if="nullError">{{ nullError }}</div>
                </div>
                <div class="col-4">
                  <button :disabled="notifyBtnDisabled" class="btn btn-primary btn-block">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="product.prod_type === 1 && product.stock <= 0 && product.jit_value !== 'JIT'">
      <div style="padding:10px 0" class="bottomSection">
        <h6 class="mb15">Get notified once the product is back in stock.</h6>
        <form method="POST" v-on:submit.prevent="notifyproduct">
          <div class="form-group">
            <div class="row">
              <input type="hidden" v-model="notify.prod_id" :value="parentid">
              <input type="hidden" v-model="notify.prod_type" :value="proType">
              <div class="col-8">
                <input type="text" placeholder="Enter your email ID" name="notify.email" v-model="email" class="form-control">
                <div class="message" v-if="nullError">{{ nullError }}</div>
              </div>
              <div class="col-4">
                <button :disabled="notifyBtnDisabled" class="btn btn-primary btn-block">Submit</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex'
  export default {
    props: ['szid', 'parentid', 'proType', 'isOptions', 'position', 'sizes', 'isSouledOut', 'isMoveToCartPopup', 'platform'],
    data: function () {
      return {
        showPopup: false,
        timer: '',
        isInInfo: false,
        email: '',
        notify: {
          prod_id: this.parentid,
          sub_prod_id: this.selectedSize,
          prod_type: this.proType,
          email: ''
        },
        nullError: '',
        selectedSize: '',
        notifyBtnDisabled: false
      }
    },
    mounted: function () {
      this.email = this.authStatus ? this.user.email : ''
    },
    watch: {
      authStatus () {
        this.email = this.authStatus ? this.user.email : ''
      }
    },
    methods: {
      changeSize: function (selectedVariant) {
        this.selectedSize = selectedVariant
      },
      notifyproduct: function () {
        let email = this.email
        let verify = false
        let emailVal = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
        this.nullError = ''
        let notifyForm = new FormData()
        notifyForm.append('email', email)
        notifyForm.append('prod_id', this.notify.prod_id)
        notifyForm.append('sub_prod_id', this.selectedSize)
        notifyForm.append('prod_type', this.notify.prod_type)
        if (!email && !this.selectedSize && this.isOptions === true) {
          if (this.platform === 'KIDS') {
            this.nullError = 'Please enter email and age.'
          } else {
            this.nullError = 'Please enter email and size.'
          }
          verify = true
        } else if (!this.selectedSize && this.isOptions === true) {
          if (this.platform === 'KIDS') {
            this.nullError = 'Please select the age.'
          } else {
            this.nullError = 'Please select the size.'
          }
          verify = true
        } else if (!verify && emailVal.test(email)) {
          this.nullError = ''
          this.notifyBtnDisabled = true
          this.$store.dispatch('SET_PRODUCT_STOCK_NOTIFICATION', notifyForm).then((response) => {
            if (response.data.status) {
              this.email = this.authStatus ? this.user.email : this.email
              this.notify.email = ''
              this.$parent.notifyvalid = true
              this.$parent.notifymsg = response.data.message
              this.closePopover()
              this.notifyBtnDisabled = false
              this.$store.dispatch('TATVIC_EVENT', {eventName: 'PDP_NOTIFY_ME_SUBMIT',
                payload: {
                  PRODUCT_NAME: this.product.product,
                  PRODUCT_CATEGORY: this.product.category,
                  ARTIST_NAME: this.product.firstname.replace('\u0099', ''),
                  PARENT_SKU: this.product.id,
                  PRODUCT_TAG: this.product.product_slug || 'NA',
                  SIZE: this.getSizeName
                }}
              )
              this.$store.commit('MOENGAGE_EVENT', {eventName: 'PDP_NOTIFY_ME_SUBMIT_WEB',
                payload: {
                  PRODUCT_NAME: this.product.product,
                  PRODUCT_CATEGORY: this.product.category,
                  ARTIST_NAME: this.product.firstname.replace('\u0099', ''),
                  PARENT_SKU: this.product.id,
                  PRODUCT_TAG: this.product.product_slug || 'NA',
                  SIZE: this.getSizeName
                }}
              )
            }
          })
        } else {
          this.nullError = 'Please enter valid email address.'
          verify = false
          this.notifyBtnDisabled = false
        }
        setTimeout(() => { this.nullError = false }, 5000)
      },
      hover: function () {
        let vm = this
        this.timer = setTimeout(function () {
          vm.showPopover()
        }, 100)
      },
      hoverOut: function () {
        let vm = this
        clearTimeout(vm.timer)
        this.timer = setTimeout(function () {
          if (!vm.isInInfo) {
            vm.closePopover()
          }
        }, 100)
      },
      hoverInfo: function () {
        this.isInInfo = true
      },
      hoverOutInfo: function () {
        this.isInInfo = false
        this.hoverOut()
      },
      showPopover: function () {
        this.showPopup = true
        const getUdatednewDesignMweb = Vue.ls.get('updatednewDesignMweb')
        if (getUdatednewDesignMweb === 'NEW_DESIGN') {
          this.$store.dispatch('TATVIC_EVENT', {eventName: 'NOTIFY_ME_CLICKED',
            payload: {
              PRODUCT_NAME: this.product.product,
              PRODUCT_CATEGORY: this.product.category,
              BY_ARTIST: this.product.firstname.replace('\u0099', ''),
              PARENT_SKU: this.product.id,
              PRODUCT_TAG: this.product.product_slug || 'NA',
              Platform: 'MWEB',
              Source: 'WEB',
              NEW_UI: true
            }}
          )
        } else {
          this.$store.dispatch('TATVIC_EVENT', {eventName: 'PDP_NOTIFY_ME_INITIATE',
            payload: {
              PRODUCT_NAME: this.product.product,
              PRODUCT_CATEGORY: this.product.category,
              BY_ARTIST: this.product.firstname.replace('\u0099', ''),
              PARENT_SKU: this.product.id,
              PRODUCT_TAG: this.product.product_slug || 'NA'
            }}
          )
        }
      },
      closePopover: function () {
        this.showPopup = false
      }
    },
    computed: {
      ...mapGetters({product: 'FETCH_PRODUCT', user: 'user', authStatus: 'authStatus'}),
      getSizeName () {
        let filtSize = this.sizes && this.sizes.filter(item => {
          return item.id === this.selectedSize
        })
        if (filtSize && filtSize.length) {
          let sizeObj = filtSize[0] && filtSize[0].attributes && filtSize[0].attributes.filter(att => {
            return att.name === 'size'
          })
          return sizeObj && sizeObj.length ? sizeObj[0].value : ''
        }
      },
      getFilteredSize () {
        return this.sizes && this.sizes.filter(s => {
          return s.stock === 0
        })
      }
    }
  }
</script>
<style scoped="">
  .closebx {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #ccc;
    width: 25px;
    height: 25px;
    text-align: center;
    cursor: pointer;
  }
  .closebx:active,
  .closebx:hover{
    border: 0;
    outline: none;
  }

  .select-size{
    margin-top: 18px;
  }
  .select-size .selectcolor{
    text-decoration: underline
  }

  .user-popover {
    position: absolute;
    width: 330px;
    top: 30px;
    left: 0;
    background: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
    z-index: 99;
  }

  .user-popover .productSize{
    padding: 15px 15px 12px;
    background-color: #fafafa;
  }

  .user-popover .productSize p{
    font-size: 16px;
    margin-bottom: 10px;
  }

  .bottomSection{
    width: 100%;
    padding: 15px;
    display: inline-block;
  }

  .user-popover h3 {
    font-size: 15px;
  }

  .disableclick {
    display: block;
    position: absolute;
    width: 100%;
    left: 0;
    height: 100%;
    z-index: 99;
    font-size: 28px;
    color: #999696;
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 300;;
  }
  .bottomSection .col-8{
    padding-right: 0;
  }

  .form-control{
    border-radius: 0;
  }

  .unselectedSize {
    border: 2px #ccc solid;
  }
  .selectedSize {
    border: 2px #117a7a solid;
  }
  .sizelist{
    width: 100%;
    display: inline-block;
  }
  .sizelist li{
    margin-right: 0 !important;
    height: auto;
    width: auto;
    margin: 0;
    padding: 0;
    line-height: unset;
    margin: 2px 8px 8px 0px !important;
  } 
  .sizelist li div {
    display: inline-block;
    padding: 0px 0px;
    width: 40px;
    margin-right: 7px;
    text-align: center;
    margin-right: 8px;
    line-height: 29px;
    cursor: pointer;
    position: relative
  }
  .message{
    margin-top: 5px;
    color: rgb(255, 0, 0);
    font-size: 14px;
  }
  .oval{
    min-width: 50px;
    width: auto;
    height: 35px;
    padding: 0 10px;
    border-radius: 5px;
    /* Tranform Oval To Square */
    background-color: white
  }
  .sizelist li input[type="radio"] + label {
    line-height: 31px !important;
  }

  @media screen and (max-width: 991px) {
    .closebx {
      display: block;
    }
  }

  input,
  input::-webkit-input-placeholder {
    font-size: 15px;
  }

  @media screen and (max-width: 768px) {
    .user-popover {
      width: 335px;
    }
    .user-popover h3 {
      padding: 5px 2px;
      font-size: 14px;
    }
    .mobileOverlayLayer{
      width: 100%;
      height: 100%;
      position: fixed;
      background-color: rgba(0, 0, 0, 0.45);
      transition: width 2s, height 2s, background-color 2s;
      left: 0;
      top: 0;
      z-index: 99999;
    }
    .user-popover{
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .bx1 p, .bx1 {
      margin-bottom: 2px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// sizeHover.vue?e1f59a3c